import { render, staticRenderFns } from "./TabContentLoader.vue?vue&type=template&id=5177e601&scoped=true"
import script from "./TabContentLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./TabContentLoader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TabContentLoader.vue?vue&type=style&index=0&id=5177e601&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5177e601",
  null
  
)

export default component.exports